export enum SettingsTeammatesDataEventObjectsEnum {
  INVITE_TEAMMATE_NEW = 'teammate_invite.new',
  INVITE_TEAMMATE_NEW_CANCEL = 'teammate_invite.new.cancel',
  INVITE_TEAMMATE_BULK = 'teammate_invite.bulk',
  INVITE_TEAMMATE_BULK_CANCEL = 'teammate_invite.bulk.cancel',
}
